import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'

const NUMERIC_SORT_KEYS = new Set([
  'replaceCount',
  'remainPercent',
  'lowCount',
  'emptyCount',
  'lowEmptyPrinterCount',
  'printerCount',
  'monthlyForecast',
  'avgCycleDays',
  'slotCount',
])

export function supplyExcelStamp() {
  const d = new Date()
  const p = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}

export function sortSupplyRows(list, sort, getters = {}) {
  const key = sort?.key
  if (!key) return Array.isArray(list) ? list.slice() : []
  const dir = sort.dir === 'ASC' ? 1 : -1
  return (list || []).slice().sort((a, b) => {
    const av = getters[key] ? getters[key](a) : a?.[key]
    const bv = getters[key] ? getters[key](b) : b?.[key]
    if (NUMERIC_SORT_KEYS.has(key) || typeof av === 'number' || typeof bv === 'number') {
      return (Number(av || 0) - Number(bv || 0)) * dir
    }
    return String(av ?? '').localeCompare(String(bv ?? ''), 'ko') * dir
  })
}

export async function downloadSupplyExcel({ title, fileName, columns, rows }) {
  const workbook = new ExcelJS.Workbook()
  workbook.created = new Date()
  const sheetName = String(title || 'sheet').slice(0, 31)
  const ws = workbook.addWorksheet(sheetName)
  ws.columns = (columns || []).map((col) => ({
    header: col.header,
    key: col.key,
    width: col.width || 16,
  }))
  const headerRow = ws.getRow(1)
  headerRow.font = { bold: true, size: 10 }
  headerRow.alignment = { vertical: 'middle', horizontal: 'center' }
  ;(rows || []).forEach((row) => {
    const out = {}
    ;(columns || []).forEach((col) => {
      out[col.key] = col.value ? col.value(row) : row?.[col.key]
    })
    ws.addRow(out)
  })
  const data = await workbook.xlsx.writeBuffer()
  const blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  FileSaver.saveAs(blob, fileName)
}
